import React, { useContext } from 'react'
import { EmptyState } from '../../common/components/empty-state'
import { FloatingBackLink } from '../../common/components/floating-back-link'
import { RouterContext } from '../../common/contexts/routerContext'

import { useStyles } from './report-viewer-empty-state.style'

export const ReportViewerEmptyState = ({ report }) => {
  const classes = useStyles()
  const routerContext = useContext(RouterContext)

  return <>
    <FloatingBackLink to={routerContext.getReportListRoute(report)} />
    <div className={classes.emptyState} data-qa="report-empty-state">
      <EmptyState>
          Some amazing content is coming soon to this location.
      </EmptyState>
    </div>
  </>
}
